export default "__VITE_ASSET__2b5ad635__$_?nuxt_component=async&nuxt_component_name=SvgoHelp2944728__"